// extracted by mini-css-extract-plugin
module.exports = {"galleryCarousel":"styles_galleryCarousel__4Aahi","item":"styles_item__f9L8g"};